// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appDomain: 'https://developer.afrogift.com.ng',
  api: 'https://developer.afrogift.com.ng/api',
  pub_key: "7f2G4iAwNUrJcGe05gNUrJBYZjsGkcAY0LWp9ck0826oA0826wNUrJcAf2G2G4iAnrY0LWp9n",
  paystack: "",
  tawkexternal: "",
  wallet: "",
  serverAddress: '100.85.124.80',
  ipApi: 'https://ipapi.co/json/',
  infurakey: "",
  partnerConnect: 'https://100.85.124.80:1967',
  adminAddress: 'somtobuchi@gmail.com',
  authUrl: 'https://100.85.124.80:1959',
  afro: 'https://ag.rarebreedmentribe.org.uk'

};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
